// returns true, if the given parameter is a string
// returns false, if not
export function isString(value) {
  return Object.prototype.toString.call(value) === '[object String]';
}
